import React, { useState, useEffect } from 'react';
import ReactInterval from 'react-interval';
import { getUserInfoByToken, submitNewPassword } from "../../store/action/user"
import { Button } from "../../components/buttons";

const NewPassword = (props) => {
    const [ values, setValues ] = useState({
        email:'',
        password:'',
        error:'',
        submitLoading: false,
        pageLoading: true,
        redirectToReferrer: false,
        passwordSent:false
    });

    useEffect(async () => {
        try {
            const res = await getUserInfoByToken(props.match.params.token);
            if (res.success) {
                setValues({...values,email:res.email, pageLoading:false})
            } else {
                setValues({...values,error:res.error, pageLoading:false})
            }
        } catch (e) {
            alert(e.message)
            setValues({...values, pageLoading:false})
        }
    },[]);

    const onSubmit = async () => {
        try {
            const res = await submitNewPassword(values.email,values.password);
            if (res.success) {
                setValues({...values, passwordSent:true, submitLoading:false});
            } else {
                setValues({...values, error:res.error, submitLoading:false});
            }
        } catch (e) {
            console.log (e)
            setValues({...values, error:e.message, submitLoading:false});
        }
    };

    const handleChange = name => event => {
        setValues({ ...values, error: false, [name]: event.target.value });
    };

    const showError = () => (
        <div
            className="alert alert-danger mb-0"
            style={{display: values.error ? '' : 'none'}}
        >
            { values.error }
        </div>
    );

    const onLoading = e => {
        setValues({ ...values, loading:true})
    };

    if (values.passwordSent){
        return (
            <div className="row">
                <div className="col-4"/>
                <div className="col-4">
                    <br/>
                    <br/>
                    <div className="card p-4 text-center">
                        <br/>
                        <div className="align-items-center">
                            <h2>
                                <strong className="text-primary">
                                    biteship
                                </strong>
                            </h2>
                        </div>
                        <br/>
                        <h6>
                            Password sudah berhasil diganti, silahkan Login kembali.
                        </h6>
                        <br/>
                        <a href={`https://dashboard.biteship.com/signin`}>Kembali ke Halaman Login</a>
                    </div>
                </div>

            </div>
        )
    }

    if (values.pageLoading) {
        return (<p>Loading...</p>)
    }

    return (
        <div className="row">
            <ReactInterval
                timeout={2000}
                enabled={values.submitLoading}
                callback={() => onSubmit()}
            />
            <div className="col-4"/>
            <div className="col-4">
                <br/>
                <br/>
                <div className="align-items-center">
                    <h1 className="text-center">
                        <i>
                            <strong style={{color:'#ff2f6c'}}>
                                swift
                            </strong>
                        </i>
                    </h1>
                </div>

                <br/>

                <div className="card p-4">
                    { showError() }
                    { !values.email ? null :
                    <div>
                        <h4>Password Baru</h4>
                        <div className="form-group">
                            <label htmlFor="exampleInputEmail1">Masukkan password baru Anda untuk akun <b>{values.email}</b></label>
                            <input
                                type="password"
                                onChange={handleChange('password')}
                                placeholder="Password"
                                className="form-control"
                                values={values.password}
                            />
                        </div>

                        <Button
                            onClick={() => setValues({...values, submitLoading:true})}
                            loading={values.submitLoading}
                            className="btn btn-primary btn-block"
                        >
                            {values.submitLoading ? "Submitting..." : "Submit Password"}
                        </Button>
                    </div>}
                </div>
            </div>
        </div>
    );
};

export default NewPassword;
